
















import { Prop, Vue } from 'vue-property-decorator'

interface ItemTabs {
  key: number;
  value: string;
}

export default class Tabs extends Vue {
  @Prop({ type: Array, default: [] }) private itemTabs!: ItemTabs[]
  @Prop({ type: Number, default: 0 }) private currentTab!: number

  get dataItems(): string {
    return this.$attrs.itemTabs
  }
}
